<template>
  <router-link @click.native="routeToAnchor" :to="to">
    <slot/>
  </router-link>
</template>

<script>
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default {
  name: "vue-anchor-router-link",
  props: {
    to: Object,
    scrollOptions: {
      type: [Object, Number],
      default: 1
    }
  },
  computed: {
  user: function() { return this.$store.getters.get('user') }
  },
  data() {
    return {
      previousRoute: this.$route
    };
  },
  methods: {
    routeToAnchor() {
        this.$gtag.event(this.$route.hash.replace(/#/, ''), {
                'event_category': 'views',
                'event_label': this.user.username ? this.user.username : 'not logged in'
        })
            let event = 'navbar-mobile';
            this.$root.$emit(event, 'close');
      if ( this.$route.hash && this.$route.fullPath === this.previousRoute.fullPath ) {
      setTimeout(() => {
        document.getElementById(this.to.hash.replace(/#/,'')).scrollIntoView({alignToTop: false, behavior: 'smooth'}) 
       },0)
      }
    }
  },
  watch: {
    $route: function(newRoute, oldRoute) {
      this.previousRoute = newRoute;
    }
  }
};
</script>

<style>
</style>
